import i18n from "../i18n";
import ensureSingleExecution from "../middleware/ensureSingleExecution";
import { jsonGetRoute } from "./json-get-route";

const AnnualPlanner = (app) => {
  app.post(
    "/annual-planner/add-calendar-event",
    ensureSingleExecution,
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;
      !body.event_to && delete body.event_to;
      try {
        await api(`calendar-event`, {
          method: "POST",
          body,
        });

        flash(
          "success",
          i18n.t("coaching-portal:annualPlannerActions.successfullyAdded")
        );

        res.refreshWith(
          {
            "modal[type]": "",
            eventTo: "",
            eventFrom: "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);

        res.refreshWith(
          {
            "modal[type]": "add-event",
            section: body.modalParams?.section,
            date: body.modalParams?.date,
            athlete: body.modalParams?.athlete,
            eventTo: "",
            eventFrom: "",
          },
          { url: body.modalUrl, hash: "#_" }
        );
      }
    }
  );
  app.post(
    "/annual-planner/update-calendar-event",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      try {
        await api(`calendar-event`, {
          method: "PUT",
          body,
        });

        flash(
          "success",
          i18n.t("coaching-portal:annualPlannerActions.successfullyUpdated")
        );

        res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({ url: "back", hash: "#_" });
      }
    }
  );

  app.post(
    "/annual-planner/remove-calendar-event",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;
      const { athleteId, eventId, organizationCoachId = undefined } = body;

      let url = `calendar-event?athleteId=${athleteId}&eventId=${eventId}`;

      if (organizationCoachId) {
        url = `calendar-event?athleteId=${athleteId}&eventId=${eventId}&organizationCoachId=${organizationCoachId}`;
      }

      delete body.organizationCoachId;

      try {
        await api(url, {
          method: "DELETE",
          body,
        });

        flash(
          "success",
          i18n.t("coaching-portal:annualPlannerActions.successfullyRemoved")
        );

        res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({ url: "back", hash: "#_" });
      }
    }
  );
  app.post(
    "/annual-planner/phase-template",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;
      const { organizationOwner } = locals;

      body.organizationOwnerId = organizationOwner?._id;

      try {
        await api(`coach-phase-template`, {
          method: "POST",
          body,
        });

        flash(
          "success",
          i18n.t("coaching-portal:annualPlannerActions.successfullyAdded")
        );

        res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );
  app.post(
    "/annual-planner/update-phase-template",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;
      const { organizationOwner } = locals;

      body.organizationOwnerId = organizationOwner?._id;

      try {
        await api(`coach-phase-template`, {
          method: "PUT",
          body,
        });

        flash(
          "success",
          i18n.t("coaching-portal:annualPlannerActions.successfullyUpdated")
        );

        res.refreshWith(
          {
            "modal[type]": "phase-templates",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );
  app.post(
    "/annual-planner/remove-phase-template",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;
      const { organizationOwner } = locals;

      const organizationCoachId = body.organizationCoachId || undefined;
      const organizationOwnerId = organizationOwner?._id;

      // Interpolating an undefined value into a template string gives the literal text
      // "undefined", which the api parses as a truthy string id and tries to cast to an
      // ObjectId - only append these when they have a real value, same as the other
      // handlers in this file that already guard with `if (organizationCoachId)`
      let url = `coach-phase-template?templateId=${body.templateId}`;
      if (organizationCoachId)
        url += `&organizationCoachId=${organizationCoachId}`;
      if (organizationOwnerId)
        url += `&organizationOwnerId=${organizationOwnerId}`;

      delete body.organizationCoachId;

      try {
        const response = await api(url, {
          method: "DELETE",
          body,
        });

        if (!response.ok) {
          flash(
            "error",
            response.statusText ||
              i18n.t("coaching-portal:annualPlannerActions.errorRemovingPhase")
          );
          return res.refreshWith({}, { url: "back", hash: "#_" });
        }

        flash(
          "success",
          i18n.t("coaching-portal:annualPlannerActions.successfullyDeleted")
        );

        res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );

  app.post(
    "/annual-planner/remove-default-template",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;
      const { organizationOwner } = locals;
      const organizationCoachId = body.organizationCoachId || undefined;
      const organizationOwnerId = organizationOwner?._id;

      // See remove-phase-template above: only append when there is a real value
      let url = `coach-phase-template?removeDefault=${body.removeDefault}`;
      if (organizationCoachId)
        url += `&organizationCoachId=${organizationCoachId}`;
      if (organizationOwnerId)
        url += `&organizationOwnerId=${organizationOwnerId}`;

      delete body.organizationCoachId;

      try {
        const response = await api(url, {
          method: "DELETE",
          body,
        });

        if (!response.ok) {
          flash(
            "error",
            response.statusText ||
              i18n.t("coaching-portal:annualPlannerActions.errorRemovingPhase")
          );
          return res.refreshWith({}, { url: "back", hash: "#_" });
        }

        flash(
          "success",
          i18n.t("coaching-portal:annualPlannerActions.successfullyRemoved")
        );

        res.refreshWith(
          {
            "modal[type]": "phase-templates",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );

  app.post(
    "/annual-planner/set-athlete-phases",
    ensureSingleExecution,
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      const { organizationOwner } = locals;

      const organizationOwnerId = organizationOwner?._id;
      organizationOwnerId && (body.organizationOwnerId = organizationOwnerId);

      try {
        await api(`athlete-phases`, {
          method: "POST",
          body,
        });

        body.onlySetDefault
          ? flash(
              "success",
              i18n.t(
                "coaching-portal:annualPlannerActions.successfullySetAsDefault"
              )
            )
          : flash(
              "success",
              i18n.t(
                "coaching-portal:annualPlannerActions.phasesSuccessfullySet"
              )
            );

        res.refreshWith(
          {
            "modal[type]": "",
            changedTemplate: true,
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );
  app.post(
    "/annual-planner/update-athlete-phase",
    ensureSingleExecution,
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      try {
        await api(`athlete-phases`, {
          method: "PUT",
          body,
        });

        flash(
          "success",
          i18n.t("coaching-portal:annualPlannerActions.successfullyUpdated")
        );

        res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );

  app.post(
    "/annual-planner/remove-athlete-phase",
    ensureSingleExecution,
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      const {
        athleteId,
        phaseName,
        organizationCoachId = undefined,
        track = undefined,
      } = body;
      const { organizationOwner } = locals;
      const organizationOwnerId = organizationOwner?._id;

      // See remove-phase-template in this file: only append when there is a real value
      let url = `athlete-phases?athleteId=${athleteId}&phaseName=${phaseName}`;
      if (organizationCoachId)
        url += `&organizationCoachId=${organizationCoachId}`;
      if (organizationOwnerId)
        url += `&organizationOwnerId=${organizationOwnerId}`;
      // The API's DELETE handler reads `track` off req.query (not the body) -
      // without this, every removal defaulted to the training track
      // regardless of which track the phase actually belonged to.
      if (track) url += `&track=${track}`;

      delete body.organizationCoachId;

      try {
        await api(url, {
          method: "DELETE",
          body,
        }).then((res) => {
          if (res.status === 200)
            flash(
              "success",
              i18n.t("coaching-portal:annualPlannerActions.successfullyRemoved")
            );
          else
            flash(
              "error",
              res.statusText ||
                i18n.t(
                  "coaching-portal:annualPlannerActions.errorRemovingPhase"
                )
            );
        });

        res.refreshWith(
          {
            "modal[type]": "",
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );
  // * COMPLETED
  app.post(
    "/annual-planner/set-athlete-phase-attachment",
    async ({ req, locals, res, api, flash }) => {
      const { body } = req;

      const { organizationOwner } = locals;
      const organizationOwnerId = organizationOwner?._id;

      organizationOwnerId && (body.organizationOwnerId = organizationOwnerId);

      try {
        const response = await api(`athlete-phases-attachments`, {
          method: "POST",
          body,
        });

        res.refreshWith(
          {
            athleteSwitch: false,
            changedTemplate: false,
          },
          { url: "back", hash: "#_" }
        );
      } catch (e) {
        flash("error", e.message);
        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    }
  );

  // No-reload bridge for the Weekly Notes panel (WeekNotesPanel.js) - same
  // reasoning as nutrition-tdee-override.js: the panel keeps state outside
  // the URL (selected week), so a reload would lose it just to save a note.
  // These wrap the same msb-api route the reload-based actions above use.
  const forwardJsonResponse = async (res, apiCall, fallbackMessage) => {
    res.headers = res.headers || {};
    res.headers["Content-Type"] = "application/json; charset=utf-8";
    try {
      const response = await apiCall();
      const text = await response.text();
      if (!response.ok) {
        let errorPayload = { error: fallbackMessage };
        try {
          errorPayload = text ? JSON.parse(text) : errorPayload;
        } catch {
          if (text) errorPayload.error = text;
        }
        res.status = response.status;
        res.body = JSON.stringify(errorPayload);
        return;
      }
      res.status = response.status;
      res.body = text || "{}";
    } catch (e) {
      res.status = 500;
      res.body = JSON.stringify({ error: e.message || fallbackMessage });
    }
  };

  const parseJsonBody = (body) => {
    if (typeof body !== "string") return body || {};
    try {
      return JSON.parse(body);
    } catch {
      return {};
    }
  };

  app.post("/annual-planner/json/week-note", async ({ req, res, api }) =>
    forwardJsonResponse(
      res,
      () =>
        api("athlete-phases-descriptions-attachments", {
          method: "POST",
          body: parseJsonBody(req.body),
        }),
      "Failed to save note"
    )
  );

  app.put("/annual-planner/json/week-note", async ({ req, res, api }) =>
    forwardJsonResponse(
      res,
      () =>
        api("athlete-phases-descriptions-attachments", {
          method: "PUT",
          body: parseJsonBody(req.body),
        }),
      "Failed to save note"
    )
  );

  app.delete("/annual-planner/json/week-note", async ({ req, res, api }) => {
    const { dateAttachment, athleteId, organizationCoachId } = req.query;
    let url = `athlete-phases-descriptions-attachments?dateAttachment=${dateAttachment}&athleteId=${athleteId}`;
    if (organizationCoachId)
      url += `&organizationCoachId=${organizationCoachId}`;

    return forwardJsonResponse(
      res,
      () => api(url, { method: "DELETE" }),
      "Failed to delete note"
    );
  });

  // No-reload bridge for the Week Plan/Log Preview panel (WeekPlanPreview.js) -
  // same reasoning as week-note above: the panel's selected week/tab live in
  // React state, not the URL, so a reload would lose them. Proxies the same
  // calendar-plan/calendar-log msb-api routes the real Calendar page uses.
  app.get("/annual-planner/json/week-plan", async ({ req, res, api }) => {
    const { athleteId, organizationCoachId, startDate, endDate, contentType } =
      req.query;

    const apiQuery = { startDate, endDate, proxyAthlete: athleteId };
    if (organizationCoachId) apiQuery.organizationCoachId = organizationCoachId;

    const path = contentType === "log" ? "calendar-log" : "calendar-plan";

    return forwardJsonResponse(
      res,
      () => api(path, { method: "GET", query: apiQuery }),
      "Failed to load week preview"
    );
  });

  // Cycle docs for the preview's Plan tab (PlanTrainingCard needs the real
  // program/block/workout names, not just the exercise's cycle reference) -
  // same api("cycle", { query: { _id: { $in: ... } } }) call as js/load/cycle.js's
  // "cycles" loader, just reachable without a page reload.
  app.get(
    "/annual-planner/json/week-cycles",
    jsonGetRoute(
      ({ req }) => {
        const ids = (req.query.ids || "").split(",").filter(Boolean);
        if (!ids.length) return null;
        return ["cycle", { query: { _id: { $in: ids } } }];
      },
      (data) => data || []
    )
  );
};

export default AnnualPlanner;
